import { LDFlagSet, LDFlagValue } from 'launchdarkly-node-server-sdk'
import Cookies from 'js-cookie'

import { LD_SSR_FLAGS } from '@app/constants'

const LDflags: string = Cookies.get(LD_SSR_FLAGS) || ''
const flagsObj: LDFlagSet = LDflags ? JSON.parse(LDflags) : {}

export const getLDFlag: (flag: string) => LDFlagValue = flag => flagsObj[flag] || null
